import React, { useEffect } from "react";

import { Header } from "components/atoms/header/index";
import { AuthService } from "core/service/auth.service";
import { Config } from "core/service/config.service";
import { UtilService } from "core/utils/utils";
import { cocoAffiliate } from "core/utils/constants";
import { Loader } from "components/atoms/loader";

/* Included for navigation coconut users to GST and establish sessions */
export const CoconutRedirect = () => {
  useEffect(() => {
    setSessionDetials();
  }, []);

  const setSessionDetials = () => {
    const { gst_session, business_id, gst_permission, advisor } =
      UtilService.getCoconutDetials(window.location.search);
    const previousURL = document.referrer;
    const redirectDomain = UtilService.identifyEnvironment(previousURL);
    const isAdvisor = advisor && business_id;
    const coco_user = isAdvisor ? "advisor" : "direct";
    AuthService.setSessionid(gst_session);
    AuthService.setCookie("coconut_user", coco_user);
    AuthService.setCookie("coconut_business_id", business_id || "");
    AuthService.setCookie("gst_permission", gst_permission || "");
    AuthService.setCookie("coconut_advisor", advisor || "");
    AuthService.setCookie("redirect_domain", redirectDomain || "");
    redirectToSimpletaxEdit(Config.getRedirectUrl());
  };

  const redirectToSimpletaxEdit = (redirectUrl) => {
    window.location.replace(`${redirectUrl}`);
  };

  return (
    <div>
      <Header company={cocoAffiliate} />
      <Loader />
    </div>
  );
};
